import { License, State, UserSuffix } from '@uplift/api';

export const licenseRequiresCollabAgreement = (
  state: Pick<State, 'requiresCollabAgreement'> | null | undefined,
  license: Pick<License, 'role'> | null | undefined,
): boolean => !!(state?.requiresCollabAgreement && license?.role?.suffix === UserSuffix.PMHNP);
